<app-loading *ngIf="isLoading"></app-loading>

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="result-tree">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <li class="mat-tree-node">
      <button mat-icon-button [color]="tagsEnabled ? 'accent' : ''" (click)="update(node)">
        <mat-icon *ngIf="node.selected" i18n-title title="Filter">check_box</mat-icon>
        <mat-icon *ngIf="!node.selected" i18n-title title="Filter">check_box_outline_blank</mat-icon>
      </button>
      {{node.label}}
    </li>
  </mat-tree-node>
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <li>
      <div class="mat-tree-node">
        <button mat-icon-button [color]="tagsEnabled ? 'accent' : ''" (click)="update(node)" [disabled]="!node.tags">
          <mat-icon *ngIf="node.selected" i18n-title title="Filter">check_box</mat-icon>
          <mat-icon *ngIf="!node.selected" i18n-title title="Filter">check_box_outline_blank</mat-icon>
        </button>
        <button mat-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.label">
          {{node.label}}
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
      </div>
      <ul [class.result-tree-invisible]="!treeControl.isExpanded(node)">
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </mat-nested-tree-node>
</mat-tree>
